function getAnalyticsV2Proxy() {
  window.maxAnalyticsEventsV2 = window.maxAnalyticsEventsV2 || [];
  return window.maxAnalyticsEventsV2;
}

function dispatchAddToCartSubmitted(productCode, productName,itemQuantity,itemValue,stockAvailabilityStatus) {
  const action = "Confirm";
  const event = new CustomEvent("maxAnalyticsEvent", {
    detail: {
      eventName: "addProductToCart",
      page: window.location.pathname,
      eventData: {
        originID: null,
        origin: "PDP",
        originType: null,
        lineItemCount: 1,
        action,
        productCode,
        productName,
        itemQuantity,
        itemValue,
        isPunchout: "No",
        stockAvailability: stockAvailabilityStatus,
        searchId: sessionStorage.getItem("searchId"),
      }
    }
  });
  getAnalyticsV2Proxy().push(event);
}

export function addToCart(event,price,productName,stockAvailabilityStatus) {
  event.preventDefault();
  const itemQuantity = getProductQuantity()
  const totalPrice = price ? parseFloat(price) * parseFloat(itemQuantity) : 0;
  dispatchAddToCartSubmitted(getProductDetailsCode(),productName,itemQuantity,totalPrice,stockAvailabilityStatus)
}

function getProductDetailsCode() {
  const anchorTag = document.getElementById("product-detail-page")
  return anchorTag ? anchorTag.getAttribute("data-product-code") : null;
}

function getProductQuantity() {
  const anchorTag = document.getElementById("pdp-product-qty")
  return anchorTag ? anchorTag.getAttribute("value") : null;
}